import ApiService from './ApiService'

export const apiLogIn = data => ApiService.post('/user_service/auth/login/', data)
export const apiLogOut = () => ApiService.post('/user_service/users/logout/')
export const apiChangePassword = data => ApiService.post('/user_service/admin-user/change-password/', data)
export const apiForgotPassword = data => ApiService.post('/user_service/auth/forgot-password/', data)
export const apiResetPassword = (data) => ApiService.post(`/user_service/admin-user/reset-password/`, data)
export const getApiProfile = () => ApiService.get(`/user_service/user/profile/`)
export const updateApiProfile = data => ApiService.put(`/user_service/user/profile/`, data)
export const apiRefreshToken = (data) => ApiService.post('/user_service/users/refresh/', data)

